'use strict';
/* eslint no-console: 0 */
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SERVICE_WORKER_APPNA;

exports.install = install;

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

var _makeInstaller = require('service-worker-utils-client/install/makeInstaller');

var _makeInstaller2 = _interopRequireDefault(_makeInstaller);

var _appNames = require('../constants/appNames');

var _appNames2 = _interopRequireDefault(_appNames);

var _AppConfigContainer = require('../globals/AppConfigContainer');

var _AppConfigContainer2 = _interopRequireDefault(_AppConfigContainer);

var _isApp = require('./isApp');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEBUG = _enviro2.default.debug('setup_service_worker');

var NO_SERVICE_WORKER = 'no-service-worker';

var SERVICE_WORKER_APPNAME_MAP = (_SERVICE_WORKER_APPNA = {
  default: 'service-worker.js'
}, _defineProperty(_SERVICE_WORKER_APPNA, _appNames2.default.crmSignup, 'service-worker-crm.js'), _defineProperty(_SERVICE_WORKER_APPNA, _appNames2.default.crmInvited, 'service-worker-crm-invited.js'), _defineProperty(_SERVICE_WORKER_APPNA, _appNames2.default.salesSignup, 'service-worker-sales-free.js'), _defineProperty(_SERVICE_WORKER_APPNA, _appNames2.default.salesInvited, 'service-worker-sales-free-invited.js'), _defineProperty(_SERVICE_WORKER_APPNA, _appNames2.default.leadinSignup, 'service-worker-marketing-free.js'), _defineProperty(_SERVICE_WORKER_APPNA, _appNames2.default.marketingSignup, 'service-worker-marketing-free.js'), _defineProperty(_SERVICE_WORKER_APPNA, _appNames2.default.academySignup, 'service-worker-academy.js'), _defineProperty(_SERVICE_WORKER_APPNA, _appNames2.default.hubspotForStartupsSignup, 'service-worker-hubspot-for-startups.js'), _SERVICE_WORKER_APPNA);

var _getInstaller = function _getInstaller() {
  var workerBundle = SERVICE_WORKER_APPNAME_MAP[(0, _isApp.appName)()] || SERVICE_WORKER_APPNAME_MAP.default;

  if (workerBundle === NO_SERVICE_WORKER) {
    return null;
  }

  return (0, _makeInstaller2.default)({
    dependencyName: 'ProductSetupServiceWorker',
    dependencyVersion: 1,
    bundle: window.location.origin + '/configuration/' + workerBundle,
    scope: '/configuration/'
  });
};

var _doInstall = function _doInstall() {
  var installer = _getInstaller();
  if (!installer) {
    return;
  }
  installer().catch(function (err) {
    if (DEBUG) {
      console.error('setup service worker install failed.');
      console.error(err);
    }
  }).done();
};

function install() {
  var hasPrecacheBackdoor = _enviro2.default.debug('precache');
  var shouldPrecache = !_AppConfigContainer2.default.get('isMobile');
  if (shouldPrecache || hasPrecacheBackdoor) {
    _doInstall();
  }
}